import type { DeploymentShape } from '@/lib/api/contracts/workspaces'

/**
 * What this deployment offers. The workspace host context carries no
 * `deployment` shape and the build sets no `VITE_AGENT_*` flags, so it is fixed:
 * self-hosted, no billing, Chat on, and of the enterprise features only the
 * three a billing-free deployment always had.
 */
const DEPLOYMENT_SHAPE: DeploymentShape = {
  hosted: false,
  billingEnabled: false,
  chatEnabled: true,
  azureConfigured: false,
  cohereConfigured: false,
  features: {
    accessControl: false,
    auditLogs: false,
    customBlocks: false,
    dataDrains: false,
    dataRetention: false,
    inbox: true,
    sandboxes: false,
    scim: false,
    sessionPolicies: true,
    sso: false,
    usageMonitoring: false,
    whitelabeling: true,
  },
}

export function getDeploymentShape(): DeploymentShape {
  return DEPLOYMENT_SHAPE
}

export function useDeploymentShape(): DeploymentShape {
  return DEPLOYMENT_SHAPE
}
